import { useState, useEffect } from "react";
import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import { Form, Formik } from "formik";
import { useRecoilValue } from "recoil";
import { AddAppointmentRequest, GetPatientResponse, AppointmentApi, PatientApi } from "../../../api/medical-operations";
import { configState, loginInfo } from "../../../recoil/atoms";
import MainCard from "../../../styles/ui-component/cards/MainCard";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import initialAppointmentsValues from "./FormModel/initialAppointmentsValues";

import useStyles from "../../../styles/styles";
import { validationSchema } from "./FormModel/validationSchema";
import AppointmentForm from "./Forms/AppointmentForm";
import { CircularProgress } from "@mui/material";

const AddAppointment = () => {
  const loggedInEmployee = useRecoilValue(loginInfo);
  let { PatientID } = useParams();

  const classes = useStyles();
  const config = useRecoilValue(configState);
  const [patient, setPatient] = useState<GetPatientResponse>();
  const [loading, setLoading] = useState(false);

  const getAppointment = () => {
    const patient = new PatientApi(config);
    patient
      .getTenantPatientById(PatientID!)
      .then((res) => {
        setPatient(res.data);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  useEffect(() => {
    if (PatientID) {
      getAppointment();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PatientID]);

  const scheduleAppointment = (values: AddAppointmentRequest, actions: any) => {
    setLoading(true);
    const { TenantID, BranchID, DateCreated, DateModified, ...valuesToBeSubmitted } = values;
    const appointment = new AppointmentApi(config);
    appointment
      .scheduleAppointment({ ...valuesToBeSubmitted })
      .then((res) => {
        toast.success(res?.data?.Message!);        
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      })
      .finally(() => {
        setLoading(false);
      });
  };  

  const handleSubmit = (values: any, actions: any) => {
    const dateTo = new Date(values.DateFrom);
    dateTo.setMinutes(dateTo.getMinutes() + parseInt(values.Duration));
    values.DateTo = dateTo;
  
    const employeeID = values?.EmployeeID || loggedInEmployee?.EmployeeID;
  
    if (!PatientID) {
      const { Duration, EmployeeID, ...valuesToBeSubmitted } = values;
      scheduleAppointment({ ...valuesToBeSubmitted, EmployeeID: employeeID! }, actions);
    } else {
      const valuesToBeSubmitted: AddAppointmentRequest = {
        PatientID: patient?.PatientID!,
        EmployeeID: employeeID!,
        ConsultationReason: values?.ConsultationReason,
        Status: values?.Status,
        DateTo: values?.DateTo,
        Notes: values?.Notes,
        Priority: values?.Priority,
        DateFrom: values?.DateFrom,
      };
      scheduleAppointment(valuesToBeSubmitted, actions);
    }
  };

  return (
    <>
      <Box>
        <MainCard>
          <Formik
            initialValues={patient ? { ...initialAppointmentsValues, ...patient } : initialAppointmentsValues}
            enableReinitialize={true}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting }) => (
              <Form>
                <Typography variant="h3" gutterBottom sx={{ p: 0 }}>
                  {PatientID ? (
                    <>
                      {patient?.User?.FirstName.concat(
                        " ",
                        patient?.User?.MiddleName,
                        " ",
                        patient?.User?.FamilyName,
                        " "
                      )}
                      Appointment
                    </>
                  ) : (
                    "Add Appointment"
                  )}
                </Typography>
                <Divider />

                {PatientID ? (
                  <AppointmentForm isAdd isCreating/>
                ) : (
                  <AppointmentForm isCreating/>
                )}

                <Grid className={classes.buttons}>
                  <Grid className={classes.wrapper}>
                    <Button name="schedule-appointment-button" type="submit" variant="contained" color="secondary" className={classes.button} disabled={loading} startIcon={loading ? <CircularProgress size={20} /> : null}>
                      {loading ? "Submitting..." : "Schedule Appointment"}
                    </Button>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </MainCard>
      </Box>
    </>
  );
};

export default AddAppointment;
